/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { StructureDetailed } from "../model"
// @ts-ignore
import type { UpdateStructureRequest } from "../model"
/**
 * StructureResourceApi - axios parameter creator
 */
export const StructureResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get regis structure by id
     * @param {string} structureId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStructure: async (
      structureId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("getStructure", "structureId", structureId)
      const localVarPath = `/structures/{structureId}`.replace(
        "{structureId}",
        encodeURIComponent(String(structureId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update regis structure
     * @param {string} structureId
     * @param {number} projectId
     * @param {UpdateStructureRequest} updateStructureRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStructure: async (
      structureId: string,
      projectId: number,
      updateStructureRequest: UpdateStructureRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("updateStructure", "structureId", structureId)
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateStructure", "projectId", projectId)
      // verify required parameter 'updateStructureRequest' is not null or undefined
      assertParamExists("updateStructure", "updateStructureRequest", updateStructureRequest)
      const localVarPath = `/structures/{structureId}/project/{projectId}`
        .replace("{structureId}", encodeURIComponent(String(structureId)))
        .replace("{projectId}", encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateStructureRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * StructureResourceApi - functional programming interface
 */
export const StructureResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StructureResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get regis structure by id
     * @param {string} structureId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStructure(
      structureId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureDetailed>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStructure(structureId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["StructureResourceApi.getStructure"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update regis structure
     * @param {string} structureId
     * @param {number} projectId
     * @param {UpdateStructureRequest} updateStructureRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateStructure(
      structureId: string,
      projectId: number,
      updateStructureRequest: UpdateStructureRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureDetailed>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateStructure(
        structureId,
        projectId,
        updateStructureRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["StructureResourceApi.updateStructure"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * StructureResourceApi - factory interface
 */
export const StructureResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StructureResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get regis structure by id
     * @param {StructureResourceApiGetStructureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStructure(
      requestParameters: StructureResourceApiGetStructureRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StructureDetailed> {
      return localVarFp
        .getStructure(requestParameters.structureId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update regis structure
     * @param {StructureResourceApiUpdateStructureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStructure(
      requestParameters: StructureResourceApiUpdateStructureRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StructureDetailed> {
      return localVarFp
        .updateStructure(
          requestParameters.structureId,
          requestParameters.projectId,
          requestParameters.updateStructureRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getStructure operation in StructureResourceApi.
 */
export interface StructureResourceApiGetStructureRequest {
  readonly structureId: string
}

/**
 * Request parameters for updateStructure operation in StructureResourceApi.
 */
export interface StructureResourceApiUpdateStructureRequest {
  readonly structureId: string

  readonly projectId: number

  readonly updateStructureRequest: UpdateStructureRequest
}

/**
 * StructureResourceApi - object-oriented interface
 */
export class StructureResourceApi extends BaseAPI {
  /**
   *
   * @summary Get regis structure by id
   * @param {StructureResourceApiGetStructureRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getStructure(
    requestParameters: StructureResourceApiGetStructureRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StructureResourceApiFp(this.configuration)
      .getStructure(requestParameters.structureId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update regis structure
   * @param {StructureResourceApiUpdateStructureRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateStructure(
    requestParameters: StructureResourceApiUpdateStructureRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StructureResourceApiFp(this.configuration)
      .updateStructure(
        requestParameters.structureId,
        requestParameters.projectId,
        requestParameters.updateStructureRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
